import { FileLinks } from 'admin/documents/FileLinks';
import { PERIOD_TYPE_CHOICES } from 'admin/utils';
import { PropertyInsuranceProduct } from 'generated/graphql';
import {
  ArrayField,
  BooleanField,
  Datagrid,
  DateField,
  FunctionField,
  ReferenceField,
  RichTextField,
  SelectField,
  Show,
  SingleFieldList,
  TabbedShowLayout,
  TextField,
} from 'react-admin';

import { PRODUCT_STATUS_CHOICES } from '../productUtils';

export const PropertyInsuranceProductShow: React.FC = () => (
  <Show>
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Základné info">
        <TextField label="ID" source="id" />
        <ReferenceField label="Klient" link="show" reference="Client" source="client.id">
          <TextField source="user.email" />
        </ReferenceField>
        <TextField label="Inštitúcia" source="institution.name" />
        <TextField label="Vlastná inštitúcia" source="institutionName" />
        <TextField label="Názov produktu" source="name" />
        <BooleanField label="Starostlivosť" source="enableFinancialAdvisorCare" />
        <ArrayField label="Dokumenty" source="documents">
          <SingleFieldList linkType={false}>
            <ArrayField source="files">
              <FileLinks />
            </ArrayField>
          </SingleFieldList>
        </ArrayField>
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Zmluva">
        <TextField label="Číslo zmluvy" source="contractNumber" />
        <DateField label="Začiatok poistenia" locales="sk" source="contractSignDate" />
        <DateField label="Platnosť poistenia do" locales="sk" source="contractEndDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Platby">
        <FunctionField
          label="Suma poistného"
          render={(record: PropertyInsuranceProduct) =>
            record.paymentPeriod?.expectedAmount?.amount ? -record.paymentPeriod?.expectedAmount?.amount : undefined
          }
          source="paymentPeriod.expectedAmount.amount"
        />
        <TextField label="Opakovať každých" source="paymentPeriod.periodCount" />
        <SelectField choices={PERIOD_TYPE_CHOICES} label="" source="paymentPeriod.periodTypeCode" />
        <DateField label="Nasledujúca platba" locales="sk" source="paymentPeriod.expectedDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Údaje pre platbu">
        <TextField label="Variabilný symbol" source="paymentInfo.variableSymbol" />
        <TextField label="Špecifický symbol" source="paymentInfo.specificSymbol" />
        <TextField label="Konštantný symbol" source="paymentInfo.constantSymbol" />
        <TextField label="IBAN" source="paymentInfo.ibanForPayment" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poistená nehnuteľnosť">
        <TextField label="Typ" source="insuredProperty.type" />
        <TextField label="Adresa" source="insuredProperty.address" />
        <TextField label="Hodnota nehnuteľnosti" source="insuredProperty.propertyValue.amount" />
        <TextField label="Hodnota domácnosti" source="insuredProperty.householdValue.amount" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Základné poistenia">
        <ArrayField label={false} source="basicInsurances">
          <Datagrid bulkActionButtons={false}>
            <TextField label="Typ" source="type" />
            <TextField label="Poistná suma" source="insuredSum.amount" />
            <TextField label="Poistné" source="annualCost.amount" />
            <ArrayField label="Poistené riziká" source="insuranceRisks">
              <Datagrid bulkActionButtons={false}>
                <TextField label="Typ rizika" source="type" />
                <TextField label="Názov rizika" source="name" />
                <TextField label="Poistná suma" source="insuredSum.amount" />
                <TextField label="Poistné" source="annualCost.amount" />
              </Datagrid>
            </ArrayField>
          </Datagrid>
        </ArrayField>
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Pripoistenia">
        <ArrayField label={false} source="otherInsurances">
          <Datagrid bulkActionButtons={false}>
            <TextField label="Názov pripoistenia" source="name" />
            <TextField label="Poistná suma" source="insuredSum.amount" />
            <TextField label="Poistné" source="annualCost.amount" />
            <ArrayField label="Poistené riziká" source="insuranceRisks">
              <Datagrid bulkActionButtons={false}>
                <TextField label="Typ rizika" source="type" />
                <TextField label="Názov rizika" source="name" />
                <TextField label="Poistná suma" source="insuredSum.amount" />
                <TextField label="Poistné" source="annualCost.amount" />
              </Datagrid>
            </ArrayField>
          </Datagrid>
        </ArrayField>
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poistník">
        <TextField label="Meno" source="insuringPerson.name" />
        <TextField label="Priezvisko" source="insuringPerson.surname" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Status">
        <SelectField choices={PRODUCT_STATUS_CHOICES} label="Status" source="status" />
        <DateField label="Zmena stavu" locales="sk" source="statusChangeDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poznámka">
        <RichTextField label="Poznámka" source="note" />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  </Show>
);
